<template>
<div class="chapter">
<div class="inner_page">
<p class="fig"><a id="page_ii"><img alt="image" src="images/pg_ii.jpg"/></a></p><a id="page_ii">
<p class="poemt"><i>What My Last Man Did</i></p>
<p class="poem">Andrea Lewis</p>
<p class="poemt"><i>Girl with Death Mask</i></p>
<p class="poem">Jennifer Givhan</p>
<p class="poemt"><i>Fierce Pretty Things</i></p>
<p class="poem">Tom Howard</p>
<p class="poemt"><i>The Artstars</i></p>
<p class="poem">Anne Elliott</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?c40cdab0